<template>
    <div class="FormDate" @keyup.capture="updateValue">
        <input
            ref="day"
            v-model="day"
            class="FormDate__input FormDate__input--day"
            type="number"
            placeholder="dd"
            @input="updateDay"
            @click="clickInputHandler('day')"
            @blur="day && (day = day.padStart(2, 0))">

        <span class="FormDate__divider">/</span>

        <input
            ref="month"
            v-model="month"
            class="FormDate__input FormDate__input--month"
            type="number"
            placeholder="mm"
            @input="updateMonth"
            @click="clickInputHandler('month')"
            @blur="month && (month = month.padStart(2, 0))">

        <span class="FormDate__divider">/</span>

        <input
            ref="year"
            v-model="year"
            class="FormDate__input FormDate__input--year"
            type="number"
            placeholder="yyyy"
            @click="clickInputHandler('year')"
            @blur="year && (year = year.padStart(4, 0))">
    </div>
</template>

<script>
export default {
        name: `FormDate`,
        props: {
            value: {
                type: [Number, String],
                required: true,
            }
        },
        data() {
            return {
                day: `${this.value ? this.value.split('-')[2] : ``}`,
                month: `${this.value ? this.value.split('-')[1] : ``}`,
                year: `${this.value ? this.value.split('-')[0] : ``}`,
                currentYear: new Date().getFullYear().toString(),
            };
        },
        watch: {
            value: {
                immediate: true,
                handler(value) {
                    this.syncValue(value)
                }
            },
            year(current, prev) {
                if (current > this.currentYear || parseInt(current) > parseInt(this.currentYear)) this.year = this.currentYear;
            },
        },
        methods: {
            syncValue(value) {
                const dateValue = `${value || ''}`
                const [year = '', month = '', day = ''] = dateValue.split('-')
                this.day = day
                this.month = month
                this.year = year
            },
            startInput() {
                this.$nextTick(_ => {
                    this.$refs.day.select()
                    this.$refs.day.focus()
                })
            },
            clickInputHandler(t) {
                this[t] && this.$refs[t].select()
            },
            updateDay() {
                if (!this.day.length || (parseInt(this.day, 10) < 4 && this.day.length < 2)) return;
                if (parseInt(this.day) > 31) {this.day = '31'}
                this.$refs.month.select()
            },
            updateMonth() {
                if (!this.month.length || (parseInt(this.month, 10) < 2) && this.month.length < 2) return;
                if (parseInt(this.month) > 12) {this.month = '12'}
                this.$refs.year.select()
            },
            updateValue() {
                const res = `${this.year.padStart(4, 0)}-${this.month}-${this.day}`
                const timestamp = Date.parse(res);
                if (Number.isNaN(timestamp)) {
                    return
                }
                this.$emit(`input`, res);
            },
        },
    };
</script>

<style lang="scss">
    .FormDate {
        $spacing: 0.75em;

        display: inline-flex;
        position: relative;
        overflow: hidden;
        /*border: 1px solid #888;*/
        /*border-radius: 0.25em;*/

        // 1. Hide the spinner button in Chrome, Safari and Firefox.
        &__input {
            padding: $spacing;
            padding-right: calc(#{$spacing} / 2);
            padding-left: calc(#{$spacing} / 2);
            border: none;
            text-align: center;
            /* stylelint-disable-next-line property-no-vendor-prefix */
            -moz-appearance: textfield; // 1

            &::-webkit-inner-spin-button {
                display: none; // 1
            }

            &:first-child {
                padding-left: $spacing;
            }

            &:last-child {
                padding-right: $spacing;
            }

            &:focus {
                outline: none;
            }

            &--day,
            &--month {
                width: 3em;
            }

            &--year {
                width: 4em;
            }
        }

        &__divider {
            padding-top: $spacing;
            padding-bottom: $spacing;
            pointer-events: none;
        }
    }
</style>
